<ng-template #langSection>
  @if (eLang.length === 2) {
    <div class="languages">
      @for (lang of allLanguages; track lang.code) {
        @if (eLang.includes(lang.code)) {
          <img
            [ngClass]="{ langActive: activeLang === lang.code }"
            (click)="switchLang(lang.code)"
            [src]="uiAssetsPrefix + 'assets/images/languagebuttons/btn_' + lang.img + '.png'"
            class="img_lang"
          />
        }
      }
    </div>
  }
  @if (eLang.length > 2) {
    <div class="langDropDown" (clickOutside)="closeDown()">
      <div
        class="activeEntry"
        [ngClass]="{ marginRight: mediaLib.isFromMediaLibrary() }"
        (click)="toggleDown(true)"
      >
        {{ selectedLanguage }}
        <div [ngClass]="{ rotateDown: down }" class="dropDownArrow"></div>
      </div>
      <div class="dropDown" [ngClass]="{ downActive: down }">
        @for (item of fullLanguage; track item.value) {
          <div class="entry" (click)="switchLang(item.value)">{{ item.name }}</div>
        }
      </div>
    </div>
  }
</ng-template>

<!-- ═══════════ Mediathek: Rücksprung ins Dashboard (ab 1280px im Header) ═══════════ -->
<ng-template #mediaLibraryLink>
  @if (showMediaLibraryLink() && screenwidth > 1280) {
    <a [href]="backLinkWithLang()" class="media_library">
      <div class="media_library_arrow_left"></div>
      <span class="media_library_text">{{ eLangGlob().translateMediaLibraryShort }}</span>
    </a>
  }
</ng-template>

<!-- ═══════════ Mediathek: Schalter für das Event-Menü ═══════════ -->
<ng-template #eventMenuToggle>
  @if (showEventMenu()) {
    <div
      (click)="toggleBurger()"
      [ngClass]="{ active: mediaLib.panelOpen(), leftSide: langPosition === 'left' }"
      class="hamburgerNav"
    >
      <span class="line line1"></span>
      <span class="line line2"></span>
      <span class="line line3"></span>
    </div>
  }
</ng-template>

<!--
  Sprachwahl und Mediathek-Bedienelemente teilen sich eine Spalte. Die Reihenfolge folgt
  der Spalte: links steht der Menü-Schalter außen, rechts der Rücksprung-Link.
-->
<ng-template #headerControls>
  @if (mediaLib.isFromMediaLibrary()) {
    <div class="headerControl">
      @if (langPosition === 'left') {
        <ng-container *ngTemplateOutlet="eventMenuToggle"></ng-container>
        <ng-container *ngTemplateOutlet="langSection"></ng-container>
        <ng-container *ngTemplateOutlet="mediaLibraryLink"></ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="mediaLibraryLink"></ng-container>
        <ng-container *ngTemplateOutlet="langSection"></ng-container>
        <ng-container *ngTemplateOutlet="eventMenuToggle"></ng-container>
      }
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="langSection"></ng-container>
  }
</ng-template>

<header class="hr_logos" [ngClass]="{ hr_logos_fixed: mediaLib.panelOpen() }">
  <div class="hr_logo_left">
    <div [class.mainlogo]="eSetup?.mainLogoPosition === 'left'">
      @if (langPosition === 'left') {
        <ng-container *ngTemplateOutlet="headerControls"></ng-container>
      }
    </div>
    @if (eSetup?.secondLogoPosition === 'left' && screenwidth >= 680) {
      <img id="secondLogo" [width]="eSetup?.secondLogo?.width" [src]="eSetup?.secondLogo?.route" />
    }
  </div>

  <div class="hr_logo_center">
    <div [class.mainlogo]="eSetup?.mainLogoPosition === 'middle'">
      @if (langPosition === 'middle') {
        <ng-container *ngTemplateOutlet="headerControls"></ng-container>
      }
    </div>
    @if (eSetup?.secondLogoPosition === 'middle' && screenwidth >= 680) {
      <img id="secondLogo" [width]="eSetup?.secondLogo?.width" [src]="eSetup?.secondLogo?.route" />
    }
  </div>

  <div class="hr_logo_right">
    <div [class.mainlogo]="eSetup?.mainLogoPosition === 'right'">
      @if (langPosition === 'right') {
        <ng-container *ngTemplateOutlet="headerControls"></ng-container>
      }
    </div>
    @if (eSetup?.secondLogoPosition === 'right' && screenwidth >= 680) {
      <img id="secondLogo" [width]="eSetup?.secondLogo?.width" [src]="eSetup?.secondLogo?.route" />
    }
  </div>
</header>

<!-- ═══════════ Mediathek: Event-Menü (liegt als fixe Ebene über der Seite) ═══════════ -->
@if (showEventMenu()) {
  <div
    class="hamburgerWindow"
    [ngClass]="mediaLib.panelOpen() ? 'hamburgerActive' : 'hamburgerInactive'"
  >
    <div class="hamburgerDimmer" (click)="closeBurger()"></div>
    <div class="hamburgerContent">
      @if (eventHeadline()) {
        <div class="hamburger_headline">
          <h1 class="h1">{{ eventHeadline() }}</h1>
        </div>
      }

      <!-- Unter 1280px steht der Rücksprung nicht im Header, sondern hier. -->
      @if (screenwidth <= 1280) {
        <a [href]="backLinkWithLang()" class="media_library hamburger">
          <div class="media_library_arrow_left"></div>
          <span class="media_library_text">{{ eLangGlob().translateMediaLibraryLong }}</span>
        </a>
      }

      <div class="moreEvents">{{ eLangGlob().translateFurtherEvents }}</div>
      @for (event of eventsForLang(); track event.token) {
        <div class="entry">
          <a [href]="eventUrl(event)">
            <span [ngClass]="{ activeEvent: event.token === eventToken }">
              {{ eventTitle(event) }}
            </span>
          </a>
        </div>
      }
    </div>
  </div>
}
